//SHIPMENT STATUS
export const SHIPPED = "Shipped";
export const PACKED = "Packed";
export const PREPARED = "Prepared";
